document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('qty-discount-bar');
  if (!wrapper) return;

  const tier1Qty  = +wrapper.dataset.tier1Qty;
  const tier2Qty  = +wrapper.dataset.tier2Qty;
  const tier1Disc = +wrapper.dataset.tier1Disc || 0;
  const tier2Disc = +wrapper.dataset.tier2Disc || 0;
  let original = null;
  let rawText = null;

  const qtyInput = document.querySelector('input[name="quantity"]');
  if (!qtyInput) return;

  const fillElem    = wrapper.querySelector('.bar-fill');
  const labelLeft   = wrapper.querySelector('.label-left');
  const labelCenter = wrapper.querySelector('.label-center');
  const labelRight  = wrapper.querySelector('.label-right');

  let firedTier1 = false;
  let firedTier2 = false;

  const firework = (origin = { y: 0.7 }) => {
    if (typeof confetti !== 'function') {
      console.warn("confetti fehlt");
      return;
    }
    const count = 200;
    const defaults = {
      origin,
      options: { fullScreen: { zIndex: 999999 } },
      colors: ["#D8EDE6", "#06191d", "#627779"]
    };
    function fire(ratio, opts) {
      confetti(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * ratio),
      }));
    }
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2,  { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1,  { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1,  { spread: 120, startVelocity: 45 });
  };

  const fireAtLabel = (labelElem) => {
    const rect = labelElem.getBoundingClientRect();
    const origin = {
      x: (rect.left + rect.width / 2)  / window.innerWidth,
      y: (rect.top  + rect.height / 2) / window.innerHeight
    };
    firework(origin);
  };

  const getPriceBlock = () => {
    // sucht .product-info__price im nächstgelegenen Eltern-Container
    return wrapper.closest('form, .product-card, .product-info')?.querySelector('.product-info__price') || null;
  };

  function updateBar() {
    const q = Math.max(0, +qtyInput.value);
    let pct = 0, currentDisc = 0, activeLabel = labelLeft;

    if (q >= tier2Qty) {
      pct = (q / tier2Qty) * 100;
      if (!firedTier1 && tier1Disc > 0) { fireAtLabel(labelCenter); firedTier1 = true; }
      if (!firedTier2 && tier2Disc > 0) { fireAtLabel(labelRight); firedTier2 = true; }
      activeLabel = labelRight
      currentDisc = tier2Disc
    }
    else if (q >= tier1Qty) {
      pct = (q / tier2Qty) * 100;
      if (!firedTier1 && tier1Disc > 0) { fireAtLabel(labelCenter); firedTier1 = true; }
      activeLabel = labelCenter
      currentDisc = tier1Disc
    }
    else {
      pct = (q / tier1Qty) * 50;
      activeLabel = labelLeft;
      currentDisc = 0;
    }

    fillElem.style.width = `${pct}%`;
    [labelLeft, labelCenter, labelRight].forEach(l =>
      l.classList.toggle('active', l === activeLabel)
    );

    // Preisanzeige updaten
    const priceBlock = getPriceBlock();
    if (!priceBlock) return;

    const priceElem        = priceBlock.querySelector('.price');
    const priceWasElem     = priceBlock.querySelector('.price__was');
    const priceCurrentElem = priceBlock.querySelector('.price__current');

    if (!priceElem) return;

    // Originalpreis auslesen und parsen
    if(original == null){
      rawText = priceCurrentElem.textContent.trim();
      original = parseFloat(
        rawText.replace(/[^0-9,\.]/g, '').replace(',', '.')
      );
    }
    if (isNaN(original)) return;

    if (currentDisc > 0 && priceWasElem && priceCurrentElem) {
      priceElem.classList.add('price--on-sale');
      priceWasElem.textContent = rawText;
      const discounted = (original * (100 - currentDisc) / 100)
        .toFixed(2)
        .replace('.', ',');
      // ersetze nur die Ziffern-Gruppe im originalen String
      priceCurrentElem.textContent = rawText.replace(/[\d.,]+/, discounted);
    } else {
      priceElem.classList.remove('price--on-sale');
      if (priceWasElem)     priceWasElem.textContent     = '';
      if (priceCurrentElem) priceCurrentElem.textContent = rawText;
    }
  }

  qtyInput.addEventListener('change', updateBar);
  updateBar();
});
